<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="table-responsive" v-if="requests.length">
                <table class="table table-bordered table-hover mb-0">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>نام مشتری</th>
                            <th>مبلغ</th>
                            <th>وضعیت</th>
                            <th>شناسه ارجاع</th>
                            <th>کد پیگیری</th>
                            <th>تاریخ</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(request,index) in requests" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ request.customerName }}</td>
                            <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.amount) }} ریال</td>
                            <td>{{ request.flowStepStatusTitle }}</td>
                            <td>{{ request.walletRrn || '-' }}</td>
                            <td>{{ request.walletTrac || '-' }}</td>
                            <td>{{ request.createdAt }}</td>
                            <td>
                                <router-link :to="{name: 'cashback.show',params: {id: request.requestId}}" class="d-inline-block ml-2" title="مشاهده"><i class="ti-eye operationsIcon"></i></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            requests: [],
            showLoading: true,
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Wallet/CashBack/GetAll').then(({data}) => {
                if(data.status)
                    this.requests = data.result;
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>